<template>
  <div class="product-detail">
    <el-row>
      <el-col :xs="20" :sm="10" :md="10" :lg="6" :xl="6" :offset="3">
        <el-card shadow="hover">
        <el-image style="width: 100%"
          :src="'https://dmafilemanagement.s3.ap-southeast-1.amazonaws.com/images/' + productDetail.img_url"
          :preview-src-list="['https://dmafilemanagement.s3.ap-southeast-1.amazonaws.com/images/' + productDetail.img_url]">
        </el-image>
      </el-card>
        <!-- <img class="m-t-20" style="width: 200px; height: 220px" :src="'https://dmafilemanagement.s3.ap-southeast-1.amazonaws.com/images/' + productDetail.img_url" fit="cover" /> -->
      </el-col>
      <el-col :xs="20" :sm="10" :md="10" :lg="6" :xl="6" :offset="1">
        <el-row class="product-info">
          <el-col>
            <h2>{{ productDetail.name }}</h2>
          <p class="price">{{ productDetail.price | formatCurrency }}</p>
          <p>{{ productDetail.description }}</p><br>
          <el-input-number
                size="mini"
                v-model="productDetail.count"
                :min="1"
                :max="1000"
          >{{ productDetail.count }}</el-input-number><br>
          <el-button class="signup_button m-t-50" type="primary" @click="add_product_to_basket()">{{$t('addtocard')}}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import services from '@/helpers/services.js'
export default {
  data () {
    return {
      productDetail: {
        name: '',
        description: '',
        price: 0,
        product_code: 0,
        img_url: '',
        count: 1,
        categories: {
          category_name: 'хоосон'
        }
      }
    }
  },
  created () {
    this.getProductDetail(this.$route.query.product_id)
  },
  methods: {
    getProductDetail (data) {
      this.$root.fullscreenLoading = true
      const payload = {
        product_id: data
      }
      services.getProductByID(payload).then((response) => {
        response.data.count = 1
        this.productDetail = response.data
        this.$root.fullscreenLoading = false
      })
    },
    add_product_to_basket () {
      const basketItem = {
        id: this.productDetail.id,
        product_name: this.productDetail.name,
        item_price: this.productDetail.price,
        item_count: this.productDetail.count,
        img_url: this.productDetail.img_url,
        product_id: this.productDetail.id
      }
      this.$store.dispatch('add_basket', basketItem)
      this.$notify({
        title: 'Амжилттай',
        message: 'Таны сонгосон бүтээгдэхүүн сагсанд нэмэгдлээ',
        type: 'success',
        position: 'top-right'
      })
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
